import _ from "lodash";
import {
  CLEAR_GAME_STATE,
  ADD_GAME_ACTIVITY,
  SET_SELECTED_STAGE,
  SET_SELECTED_BLOCK,
  SET_GAME_CASE,
  SET_GAME_STATUS,
  SAVE_HISTORY_TAKING,
  SET_GAME_PAGE,
  ADD_CHECKLIST,
  DELETE_CHECKLIST,
  UPDATE_CHECKLIST,
  SET_PRESENTATION_FLAG,
} from "../types";

export const initialState = {
  selectedStage: { id: "", name: "" }, // will not be remove when clear game state
  case: {
    presentation: "",
    investigation: [],
    complaints: [],
  },
  status: 0,
  activity: [],
  historyTaking: [],
  // diagnosis type: provisional, differential, final
  differential: [{ id: "0", type: "differential", item: "", result: null }],
  provisional: [{ id: "0", type: "provisional", item: "", result: null }],
  final: [{ id: "0", type: "final", item: "", result: null }],
  // management type: long, short
  short: [{ id: "0", type: "short", item: "", result: null }],
  long: [{ id: "0", type: "long", item: "", result: null }],
  page: "",
  onViewStatus: 0,
  selectedBlock: "",
  presentationFlag: false,
};

export default (state = initialState, action) => {
  let category;
  let newState;

  switch (action.type) {
    case SET_PRESENTATION_FLAG:
      return { ...state, presentationFlag: action.payload };
    case SET_SELECTED_STAGE:
      return { ...state, selectedStage: action.payload.stage };
    case SET_SELECTED_BLOCK:
      return { ...state, selectedBlock: action.payload.block };
    case SET_GAME_CASE:
      return { ...state, case: action.payload.case };
    case SET_GAME_STATUS:
      return { ...state, status: action.payload.status };
    case ADD_GAME_ACTIVITY:
      return {
        ...state,
        activity: [...state.activity, action.payload],
      };
    case SAVE_HISTORY_TAKING:
      return {
        ...state,
        historyTaking: [...state.historyTaking, action.payload],
      };
    case SET_GAME_PAGE:
      return {
        ...state,
        page: action.payload.page,
        onViewStatus: action.payload.onViewStatus,
      };
    case CLEAR_GAME_STATE:
      const selectedStage = state.selectedStage;
      return {
        ...initialState,
        selectedStage: selectedStage,
      };
    case ADD_CHECKLIST:
      category = action.payload.category;

      newState = { ...state };

      newState[category] = [...state[category], action.payload.details];

      return newState;
    case DELETE_CHECKLIST:
      category = action.payload.category;

      newState = { ...state };

      newState[category] = _.filter(state[category], (checklist) => {
        return checklist.id !== action.payload.id;
      });

      return newState;
    case UPDATE_CHECKLIST:
      category = action.payload.category;

      newState = { ...state };

      let newArray = [];

      _.forEach(state[category], (checklist) => {
        if (checklist.id === action.payload.details.id) {
          checklist.item = action.payload.details.item;
          checklist.type = action.payload.details.type;
          checklist.result = action.payload.details.result;
        }
        newArray.push(checklist);
      });

      newState[category] = newArray;

      return newState;
    default:
      return state;
  }
};
